import api from "./axios";
import type { Attendance } from "@/types";

export const getAttendances = () =>
  api.get<Attendance[]>("/attendances").then((r) => r.data);
export const getAttendance = (id: string) =>
  api.get<Attendance>(`/attendances/${id}`).then((r) => r.data);
export const createAttendance = (data: Partial<Attendance>) =>
  api.post<Attendance>("/attendances", data).then((r) => r.data);
export const updateAttendance = (id: string, data: Partial<Attendance>) =>
  api.patch<Attendance>(`/attendances/${id}`, data).then((r) => r.data);
export const deleteAttendance = (id: string) =>
  api.delete(`/attendances/${id}`);
